import classNames from 'classnames';
import {observer} from 'mobx-react';
import React, {useState, useEffect} from 'react';

import {useI18n} from '@udemy/i18n';
import {Button} from '@udemy/react-core-components';
import {ShoppingClient, CouponStore} from '@udemy/shopping';

import {getConfig} from 'src/features/cart/config';

import {CheckoutButton} from '../checkout-button/checkout-button.react-component';
import {RedeemCouponWithCartCouponStore} from '../redeem-coupon/redeem-coupon-with-cart-coupon-store.react-component';
import {TotalPrice} from '../total-price/total-price.react-component';
import styles from './checkout-pane.module.less';

interface CheckoutPaneProps {
    couponStore?: CouponStore;
    shoppingCartVariantMobile?: boolean;
}

export const CheckoutPane: React.FC<CheckoutPaneProps> = observer(
    ({couponStore, shoppingCartVariantMobile}) => {
        const {gettext, interpolate, ngettext} = useI18n();
        const config = getConfig(gettext, interpolate, ngettext);
        const [showCoupons, setShowCoupons] = useState(true);
        const toggleCoupons = () => {
            setShowCoupons(!showCoupons);
        };

        useEffect(() => {
            ShoppingClient.validateDiscounts();
        }, []);

        if (ShoppingClient.lists.cart.isEmpty) {
            return null;
        }

        return (
            <div>
                <TotalPrice listName="cart" canShowCredit={true} />
                {!shoppingCartVariantMobile && (
                    <Button
                        udStyle="link-underline"
                        size="small"
                        className={styles['sc-checkout-pane__toggle-coupon']}
                        onClick={toggleCoupons}
                        onKeyDown={toggleCoupons}
                        tabIndex={0}
                    >
                        {showCoupons ? config.strings.hideCodes : config.strings.insertCode}
                    </Button>
                )}
                <CheckoutButton
                    className={classNames(styles['pane-checkout-button'], {
                        [styles['always-visible']]: shoppingCartVariantMobile,
                    })}
                    triggerMwebCartClickEvent={shoppingCartVariantMobile}
                    authNextUrl={config.urls.cartPage}
                />
                {showCoupons && couponStore && (
                    <div
                        className={classNames(styles['redeem-coupon-wrapper'], {
                            [styles['hide-on-mobile']]: shoppingCartVariantMobile,
                        })}
                    >
                        <RedeemCouponWithCartCouponStore
                            couponStore={couponStore}
                            isInCheckoutPane={true}
                        />
                    </div>
                )}
            </div>
        );
    },
);
